import { render, staticRenderFns } from "./resetForm.vue?vue&type=template&id=21447e44&"
import script from "./resetForm.vue?vue&type=script&lang=js&"
export * from "./resetForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports